module.exports = __webpack_public_path__ + "img/art2.a307078c.png";